import { useQuery } from '@tanstack/react-query';

import { getSettingsBasic } from '../api/api';
import { SS_QUERY_KEY } from '../constants/constants';

export const useCustomerSettingsBasicQuery = (enabled: boolean = true) => {
    const {
        data: customerBasicsData,
        isLoading: isCustomerBasicsDataLoading,
        error: customerBasicsDataError,
    } = useQuery({
        queryKey: [SS_QUERY_KEY.CUSTOMER_SETTINGS_BASIC],
        queryFn: () => getSettingsBasic(),
        select: ({ data }) => data,
        enabled,
    });

    return {
        customerBasicsData,
        isCustomerBasicsDataLoading,
        customerBasicsDataError,
    };
};
